export const POP_UP_TEXT = {
    PRIZE:'Подарок'
}